// Auth/authContext.jsx
import { createContext, useContext, useState, useEffect, useCallback } from "react"
import apiClient from "Api/apiClient"

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null)
	const [isLoading, setIsLoading] = useState(true) // true on mount while we verify session

	// Verify session on app load — asks the server if the cookie is valid
	useEffect(() => {
		const verifySession = async () => {
			try {
				const data = await apiClient.get("/auth/me")
				setUser(data.user)
			} catch {
				setUser(null)
			} finally {
				setIsLoading(false)
			}
		}
		verifySession()
	}, [])

	useEffect(() => {
		const handleUnauthorized = () => {
			setUser(null)
		}
		window.addEventListener("auth:unauthorized", handleUnauthorized)
		return () => window.removeEventListener("auth:unauthorized", handleUnauthorized)
	}, [])

	const login = useCallback(async (credentials) => {
		const data = await apiClient.post("/auth/login", credentials, {
			withCredentials: true,
		})
		setUser(data.user)
		return data
	}, [])

	const register = useCallback(async (credentials) => {
		const data = await apiClient.post("/auth/register", credentials, {
			withCredentials: true,
		})
		setUser(data.user)
		return data
	}, [])

	const logout = useCallback(async () => {
		try {
			await apiClient.post("/auth/logout", {}, { withCredentials: true })
		} finally {
			setUser(null)
		}
	}, [])

	return     <AuthContext.Provider value={{ user, setUser, isLoading, login, logout, register, isAuthenticated: !!user }}>
        {children}
    </AuthContext.Provider>
}

export const useAuth = () => {
	const context = useContext(AuthContext)
	if (!context) throw new Error("useAuth must be used within an AuthProvider")
	return context
}

export { AuthContext }